






























































































import Vue from 'vue'
import './AssetTypeModal.scss'
import FileUploader from "@/components/FileUploader/FileUploader.vue"
import Modal from "@/components/Modal/Modal.vue"
import { Feature } from '@/featureFlags/featureFlags'

export default Vue.extend({
  name: 'AssetTypeModal',
  props: {
    teamId: {
      type: String
    }
  },
  computed: {
    isUploading (): boolean {
      return this.showProgress
    },
    modalTitle (): string {
      return (this.isUploading) ? 'Uploading...' : 'Add new'
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    }
  },
  data: () => ({
    uploadType: '', // triggers a reaction of upload component
    // uploadActive: false,
    showProgress: false,
    showUpload: false,
  }),
  methods: {
    closeModal () {
      this.$emit('cancel')
    },
    async upload (uploadType) {
      this.openFileUploadSelector(uploadType)
    },
    async openFileUploadSelector (uploadType) {
      this.showUpload = true
      // force trigger an update (eg when previous was canceled)
      if (this.uploadType === uploadType) {
        this.uploadType = ''
        await this.$nextTick()
      }

      this.uploadType = uploadType
    },
    openNameSelector (uploadType) {
      this.$emit('requestName', uploadType)
      this.closeModal()
    },
    filesSelected () {
      this.showProgress = true
    },
    allFilesUploaded () {
      this.showUpload = false
      this.showProgress = false
      this.closeModal()
    },
    fileUploaded (file) {
      this.$emit('fileUploaded', file)
    }
  },
  components: {
    FileUploader,
    Modal
  }
})
